import { render, staticRenderFns } from "./attendMonth.vue?vue&type=template&id=2b87a83b&scoped=true&"
import script from "./attendMonth.vue?vue&type=script&lang=js&"
export * from "./attendMonth.vue?vue&type=script&lang=js&"
import style0 from "./attendMonth.vue?vue&type=style&index=0&id=2b87a83b&scoped=true&lang=css&"
import style1 from "./attendMonth.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b87a83b",
  null
  
)

export default component.exports